/* ── SmartPack Core — Regios DOPP bridge ── */
(function () {
  'use strict';

  function withRegios(fn) {
    if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
      fn(window.RegiosDOPP.api.v0);
    } else {
      window.addEventListener('regios-dopp:api-initialized', function (e) { fn(e.detail.api); });
    }
  }

  function qtyInput() {
    return document.querySelector('[data-sp-quantity-input], input[name="quantity"]');
  }

  function currentQuantity() {
    var input = qtyInput();
    return input ? parseInt(input.value, 10) || 1 : 1;
  }

  function spcoreOwnsPrice() {
    var el = document.querySelector('[data-sp-buy] [data-sp-band-data]');
    if (el) {
      try {
        var d = JSON.parse(el.textContent);
        if (d && d.bands && d.bands.length) return true;
      } catch (e) {}
    }
    return !!document.querySelector('[data-sp-price-table] [data-band-min]');
  }

  var renderToken = 0;

  function renderUnitPrice() {
    if (spcoreOwnsPrice()) return;
    var api = window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0;
    if (!api || !api.productPage) return;
    var container = document.querySelector('[data-sp-price]');
    if (!container) return;
    var amountEl = container.querySelector('[data-sp-b2b-price]');
    if (!amountEl) return;

    var qty = currentQuantity();
    var token = ++renderToken;

    api.productPage.calculateDiscountedPrices({ quantity: qty }).then(function (res) {
      if (token !== renderToken) return;
      if (!res || !res.salePrice || !res.regularPrice) return;
      var unitCents = Math.round((res.salePrice.amount / qty) * 100);
      var sym = (window.RegiosDOPP && window.RegiosDOPP.currencySymbol) || '$';
      amountEl.textContent = sym + (unitCents / 100).toFixed(2);
      var discounted = res.salePrice.amount < res.regularPrice.amount - 0.005;
      container.classList.toggle('sp-price--regios-discounted', discounted);
    }).catch(function () {});
  }

  var debounceTimer = null;
  function renderUnitPriceDebounced() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(renderUnitPrice, 250);
  }

  withRegios(function () {
    renderUnitPrice();
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-sp-quantity-input], input[name="quantity"]')) {
        renderUnitPriceDebounced();
      }
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-sp-quantity-input], input[name="quantity"]')) {
        renderUnitPriceDebounced();
      }
    });
  });

  function refreshPdp(variant) {
    window.dispatchEvent(new CustomEvent('regios-dopp:variant-change', {
      detail: {
        selectedVariant: { id: variant.id, price: variant.price },
        quantity: currentQuantity()
      }
    }));
  }

  withRegios(function () {
    var section = document.querySelector('[data-sp-product], [data-js-product-container]');
    if (!section || !window.themeCore || !window.themeCore.EventBus) return;
    var sectionId = section.getAttribute('data-sp-section-id') || section.getAttribute('data-section-id');
    if (!sectionId) return;

    window.themeCore.EventBus.subscribe('pdp:section-' + sectionId + ':change-variant', function (payload) {
      if (!payload || !payload.variant) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          refreshPdp(payload.variant);
          renderUnitPriceDebounced();
        });
      });
    });
  });

  window.addEventListener('sp:collection:updated', function (e) {
    window.dispatchEvent(new CustomEvent('regios-dopp:collection-page:new-items', {
      detail: {
        uniqueKey: (e.detail && e.detail.uniqueKey) || 'default',
        newItems: []
      }
    }));
  });
})();
